<ion-card
  no-margin
  margin-top
  no-box-shadow
  class="mobile-view"
  (click)="orderClicked()"
>
  <!--<ion-grid no-padding >
    <ion-row align-items-end>
      <ion-col>
        <ion-text class="item-name">{{order?.orderItems[0]?.item?.name}}</ion-text>
      </ion-col>
      <ion-col text-end d-flex align-self-end justify-content-end class="display-status">
        <ion-badge color="medium" >{{order?.displayStatusTitle}}</ion-badge>
      </ion-col>
    </ion-row>
  </ion-grid>-->
  <ion-grid no-padding class="market-order">
    <ion-row align-items-end>
      <ion-col
        class="item-name"
        size="8"
        no-padding-bottom=""
        no-padding-top=""
        no-padding-left=""
      >
        <ion-text font-bold color="dark">{{
          order?.orderItems[0]?.item?.name
        }}</ion-text>
      </ion-col>
      <ion-col
        no-padding-bottom=""
        no-padding-top=""
        no-padding-right=""
        size="4"
        class="display-status"
        text-end
        d-flex
        align-self-end
        justify-content-end
      >
        <ion-badge
          font-bold
          [OrderStatus]="
            order?.status === 'ORDER_COMPLETED'
              ? order?.payment?.orderPaymentStatus
              : order?.status
          "
          font-bold
        >
          {{
            (order.status === "ORDER_COMPLETED"
              ? order?.payment?.statusTitle
              : order?.displayStatusTitle
            ) | uppercase
          }}
        </ion-badge>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" class="order-id" no-padding="">
        <ion-text color="primary" font-regular="">Order Id • </ion-text>
        <ion-text color="primary" font-bold>{{ order?.formattedId }}</ion-text>
      </ion-col>
      <ion-col size="12" class="created-date" no-padding="">
        <ion-text color="medium">Created Date • </ion-text>
        <ion-text color="medium" font-bold>{{
          order?.createdDate | date: "dd-MMM-yyyy"
        }}</ion-text>
      </ion-col>
    </ion-row>
    <ion-row align-items-end>
      <ion-col class="rate" no-padding="">
        <ion-text color="dark"
          ><span font-bold>{{
            order?.orderItems[0]?.itemPrice | currency: "INR"
          }}</span
          ><span>/{{ order?.orderItems[0]?.item?.unitType }}</span></ion-text
        >
      </ion-col>
      <ion-col
        text-end
        align-self-end
        justify-content-end
        class="allocated-qty"
        no-padding=""
      >
        <ion-text font-regular="">Allocated Quantity</ion-text>
        <br />
        <ion-text font-bold="" color="dark">{{
          order?.formattedTotalQty || "-"
        }}</ion-text>
      </ion-col>
    </ion-row>
  </ion-grid>
  <!--<ion-item my-item margin-bottom lines="none" no-padding class="offer-bid-box" >
    <ion-icon class="icon-background ion-hide-md-up" style="position: absolute;right:0" name="ios-arrow-forward"></ion-icon>

  </ion-item>-->
</ion-card>
